class PersistedCellSizeCache {
  constructor() {
    this.rowHeightCache = {};
    this.columnWidthCache = {};
  }

  // method to manually clear all caches
  clearCaches() {
    this.rowHeightCache = {};
    this.columnWidthCache = {};
  }
  clearAllColumnWidths() {}
  clearAllRowHeights() {}
  clearColumnWidth() {}
  clearRowHeight() {}
  getColumnWidth(index) { return this.columnWidthCache[index]; }
  getRowHeight(index) { return this.rowHeightCache[index]; }
  hasColumnWidth(index) { return this.columnWidthCache[index]; }
  hasRowHeight(index) { return this.rowHeightCache[index]; }
  setColumnWidth(index, value) { this.columnWidthCache[index] = value; }
  setRowHeight(index, value) { this.rowHeightCache[index] = value; }
}

let cache = new PersistedCellSizeCache();
export default cache;




/** WEBPACK FOOTER **
 ** ./src/members/Main/Feed/FeedInfiniteLoader/PersistedCellSizeCache.js
 **/